<div class="container-fluid mb-3">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h2 class="title">{{type === 'external_supplier' ? 'Supplier User Management' : 'Internal User Management'}}</h2>
    <div class="d-flex align-items-center justify-content-center">
      <button class="btn btn-outline-primary button btn-add text-white mr-3" 
        (click)="export()">Export</button>
      <button class="btn btn-primary d-flex justify-content-center align-items-center btn-add button"
        (click)="addNewSupplier()">Add</button>
    </div>
  </div>
  <mat-card class="mt-2" style="font-size: 14px;">
    <div class="row">
      <div [ngClass]="(type=='external_supplier') ? 'col-lg-3' : 'col-lg-8'">
        <span>Search</span>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput [maxLength]="50" [(ngModel)]="search" placeholder="Search">
          <mat-hint align="end">{{search?.length || 0}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-lg-2" *ngIf="type === 'external_supplier'">
        <span>GSL Number</span>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput [maxLength]="50" [(ngModel)]="gsl" placeholder="GSL Number">
          <mat-hint align="end">{{search?.length || 0}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-lg-3" *ngIf="type === 'external_supplier'">
        <span>Parent Company</span>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput [maxLength]="50" [(ngModel)]="parentName" placeholder="Parent Name">
          <mat-hint align="end">{{search?.length || 0}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-lg-2">
        <span>Status</span>
        <mat-form-field appearance="outline" class="w-100">
          <mat-select [(ngModel)]="status">
            <mat-option value="">All</mat-option>
            <mat-option value="true">Active</mat-option>
            <mat-option value="false">Deactive</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-2 d-flex align-items-center justify-content-center">
        <button class="btn-add btn btn-outline-primary search-button" (click)="searchData()">Search</button>
      </div>
    </div>
  </mat-card>
  <table mat-table [dataSource]="dataSource" matSort class=" w-100 mt-4" (matSortChange)="sortData($event)">

    <!-- SSO column -->
    <ng-container matColumnDef="sso">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bold-header"> SSO </th>
      <td mat-cell *matCellDef="let row"> {{row.sso}} </td>
    </ng-container>

    <!-- Full Name column -->
    <ng-container matColumnDef="full_Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Full Name </th>
      <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
    </ng-container>

    <!-- Email column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
      <td mat-cell *matCellDef="let row"> {{row.email}} </td>
    </ng-container>

    <!-- Parent Company column -->
    <ng-container matColumnDef="parent_company_name" *ngIf="type === 'external_supplier'">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Parent company </th>
      <td mat-cell *matCellDef="let row"> {{row.parentName}} </td>
    </ng-container>

    <!-- Last Access column -->
    <ng-container matColumnDef="last_access">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Access </th>
      <td mat-cell *matCellDef="let row"> {{row.lastAccess}} </td>
    </ng-container>

    <!-- Created Date column -->
    <ng-container matColumnDef="create_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Created Date </th>
      <td mat-cell *matCellDef="let row"> {{row.createdDate}} </td>
    </ng-container>

    <!-- Created By column -->
    <ng-container matColumnDef="create_by">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Created By </th>
      <td mat-cell *matCellDef="let row"> {{row.createdBy}}</td>
    </ng-container>

    <!-- Updated Date column -->
    <ng-container matColumnDef="update_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Updated Date </th>
      <td mat-cell *matCellDef="let row"> {{row.updatedDate}} </td>
    </ng-container>

    <!-- Updated By column -->
    <ng-container matColumnDef="update_by">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Updated By </th>
      <td mat-cell *matCellDef="let row"> {{row.updatedBy}}</td>
    </ng-container>

    <!-- Action column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action </th>
      <td mat-cell *matCellDef="let row" style="text-align: center;">
        <div class="d-flex justify-content-center align-items-center">
          <span class="material-icons action" (click)="edit(row.id)" style="cursor: pointer;" [matTooltip]="'Edit'">
            create </span>
            <i class="fa fa-trash px-2 action delete" aria-hidden="true" [matTooltip]="'Remove'"
            (click)="deleteUser(row?.id, type)" style="cursor: pointer; font-size:23px"></i>
          <mat-slide-toggle class="example-margin" [checked]="row.active" (change)="changeActive(row.id, $event)">
          </mat-slide-toggle>
        </div>
      </td>
    </ng-container>

    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <app-ngx-mat-paginator class="w-100" *ngIf="!!dataSource && dataSource.data.length > 0"
    [requestOption]="requestOption" (requestOptionChange)="onChangeRequestOption($event)"></app-ngx-mat-paginator>
</div>